import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit';
import { apiHolder, apis } from 'api';
const snsMarketingApi = apiHolder.api.requireLogicalApi(apis.snsMarketingApiImpl);
const initState = {
    initialized: false,
    fetching: false,
    dateOfDay: '',
    totalQuota: 0,
    remainQuota: 0,
};
export const fetchSnsAiQuota = createAsyncThunk('sns-marketing/fetchSnsAiQuota', async () => {
    return snsMarketingApi.getSnsTaskQuota();
});
const snsAiQuotaSlicer = createSlice({
    name: 'noviceTaskSlicer',
    initialState: initState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchSnsAiQuota.pending, state => {
            state.fetching = true;
        })
            .addCase(fetchSnsAiQuota.fulfilled, (state, action) => {
            state.initialized = true;
            state.fetching = false;
            state.dateOfDay = action.payload.dateOfDay;
            state.totalQuota = action.payload.totalQuota;
            state.remainQuota = action.payload.remainQuota;
        })
            .addCase(fetchSnsAiQuota.rejected, state => {
            state.fetching = false;
        });
    },
});
export const getSnsAiQuota = createSelector((state) => state, state => state);
export const { actions } = snsAiQuotaSlicer;
export default snsAiQuotaSlicer.reducer;
